// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offer-pdf-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: #0008;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  padding: 90px 16px 32px;
}

.offer-pdf-modal-cuerpo {
  width: min(820px, 100%);
}

.offer-pdf-modal-acciones {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 10px;
}

.offer-pdf-modal-boton {
  border-radius: 8px;
  padding: 9px 16px;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  background: #111;
  border: 1px solid #111;
  color: #fff;
}

.offer-pdf-modal-boton:hover { background: #333; }

/* Al imprimir desde el pop-up solo sale la hoja: se esconde la pantalla de debajo y el fondo. */
@media print {
  body { background: #fff !important; }
  .offer-pdf-modal-acciones { display: none !important; }
  body.offer-pdf-abierto #root { display: none !important; }
  .offer-pdf-modal { position: static; background: none; padding: 0; display: block; overflow: visible; }
  .offer-pdf-modal-cuerpo { width: 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Offers/OfferPdfModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA,+BAA+B,gBAAgB,EAAE;;AAEjD,gGAAgG;AAChG;EACE,OAAO,2BAA2B,EAAE;EACpC,4BAA4B,wBAAwB,EAAE;EACtD,+BAA+B,wBAAwB,EAAE;EACzD,mBAAmB,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE,cAAc,EAAE,iBAAiB,EAAE;EACtG,0BAA0B,WAAW,EAAE;AACzC","sourcesContent":[".offer-pdf-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: #0008;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  overflow-y: auto;\n  padding: 90px 16px 32px;\n}\n\n.offer-pdf-modal-cuerpo {\n  width: min(820px, 100%);\n}\n\n.offer-pdf-modal-acciones {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.offer-pdf-modal-boton {\n  border-radius: 8px;\n  padding: 9px 16px;\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer;\n  background: #111;\n  border: 1px solid #111;\n  color: #fff;\n}\n\n.offer-pdf-modal-boton:hover { background: #333; }\n\n/* Al imprimir desde el pop-up solo sale la hoja: se esconde la pantalla de debajo y el fondo. */\n@media print {\n  body { background: #fff !important; }\n  .offer-pdf-modal-acciones { display: none !important; }\n  body.offer-pdf-abierto #root { display: none !important; }\n  .offer-pdf-modal { position: static; background: none; padding: 0; display: block; overflow: visible; }\n  .offer-pdf-modal-cuerpo { width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
